import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser, refreshWishlist } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = window.location.hash || "";
    const sid = new URLSearchParams(hash.replace(/^#/, "")).get("session_id");
    if (!sid) { navigate("/account"); return; }
    (async () => {
      try {
        const { data } = await api.post("/auth/google/session", {}, { headers: { "X-Session-ID": sid } });
        setUser(data.user);
        refreshWishlist?.();
        window.history.replaceState(null, "", "/account");
        navigate("/account", { state: { user: data.user } });
      } catch {
        navigate("/account");
      }
    })();
  }, [navigate, setUser, refreshWishlist]);

  return <div className="onusa-container py-40 text-center"><p className="label-x">SIGNING YOU IN…</p></div>;
}
